import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: false
};

const route = "devices/.components/castImportManual/redux/slice";

export const castImportManualImport = createAsyncThunk(
    "devices/.components/castImportManual/castImportManualImport",
    async (payload, { rejectWithValue }) => {
        try {
            const { esns } = payload;
            let QUERY = `
                mutation importGeometrisFromCast($esns: [String]) {
                    result: importGeometrisFromCast(esns: $esns) {
                        stepFunctionId
                        transactionId
                        transactionType
                        processStartDate
                    }
                }
            `;
            let data = await clientMutation(QUERY, { esns }, endpoints.GRAPHQL_GENERAL);
            return data?.result;
        } catch (exc) {
            ExceptionManager(exc, route, 'castImportManualImport');
            return rejectWithValue(exc);
        }
    }
);

export const castImportManualRedux = createSlice({
    name: 'devices/.components/castImportManual',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE };
        },
        openModalCastImportManual(state) {
            state.openModal = true;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(castImportManualImport.pending, (state) => {
            state.loading = true;
            state.result = null;
            state.error = false;
        });
        builder.addCase(castImportManualImport.fulfilled, (state, action) => {
            state.loading = false;
            state.result = action.payload;
        });
        builder.addCase(castImportManualImport.rejected, (state) => {
            state.loading = false;
            state.error = true;
        });
    }
});

const { actions, reducer } = castImportManualRedux;

export const { reset, openModalCastImportManual } = actions;

export default reducer;
